module.exports = __webpack_public_path__ + "static/bentonsans-regular-webfont-ae0f282e81de0a6a9472e1cd4cd8e164.woff";